export interface FetchDataParams {
  configID?: string;
  componentID?: string;
}

// BackendData type - using any to match the actual API response structure
// The actual type is defined in PiralInstance.tsx but we use a more flexible type here
export interface BackendData {
  pages: {
    [pageID: string]: any;
  };
  connectivity: any;
}

async function fetchData(configID?: string, componentID?: string): Promise<BackendData> {
  try {
    const resp = await fetch('/getData', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ config: configID, componentID, appID: configID })
    });

    if (!resp.ok) {
      const errorText = await resp.text();
      throw new Error(`Failed to fetch data: ${resp.status} ${resp.statusText}. ${errorText || ''}`);
    }

    const json = await resp.json();
    console.warn('Warn to easier see it, received data:', json);
    return json;
  } catch (error) {
    // Re-throw with more context if it's not already an Error
    if (error instanceof Error) {
      throw error;
    }
    throw new Error(`Network error: ${String(error)}`);
  }
}

export default fetchData;

